import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPatchSegmentOcr, TSegmentOcr } from '../types';

type TPatchSegmentOcrBody = {
  id: string;
  body: TPatchSegmentOcr;
};
export async function patchSegmentOcr({ id, body }: TPatchSegmentOcrBody): Promise<TSegmentOcr> {
  return mediaManagerClient
    .patch(`/api/v1/segment_ocr/${id}`, emptyStringValues(body))
    .then(response => response as unknown as TSegmentOcr);
}

type MutationFn = typeof patchSegmentOcr;

type TUsePatchSegmentOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchSegmentOcr({ config }: TUsePatchSegmentOcrParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchSegmentOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el rótulo del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del segmento se ha actualizado correctamente'));
    },
  });
}
